const createQuery = () => `
  query PaginatedQuery($url:String!, $page: Int = 1, $widgetType: String!) {
    paginatedWidget(url: $url, widgetType: $widgetType) {
      ... on PaginatedListWidget {
        totalItems
        items(page: $page) {
          title
          text
          images {
            hero_landscape_668 {
              url
              caption
              link
            }
          }
        }
      }
    }
  }
`
export default createQuery
